module.exports = require("handlebars");